export default "__VITE_ASSET__CNVSHgwo__"